import { getFromCacheById } from './indexedDBHelper';

function getRandomNumbers(n, min, max) {
    const numbers = new Set();

    while (numbers.size < n) {
        numbers.add(Math.floor(Math.random() * (max - min + 1)) + min);
    }

    return Array.from(numbers);
}

export async function AssembleTestQuestions(selectedOption) {
    const getRangeByOption = (selectedOption) => {
        const start = 301 + (selectedOption - 1) * 10;
        const end = start + 9;
        return { start, end };
    };
    const { start, end } = getRangeByOption(selectedOption);
    const stateQuestionsList = getRandomNumbers(3, start, end);
    const generalQuestionsList = getRandomNumbers(30, 1, 300);

    let questionsList = [];

    const fetchStateQuestions = [];
    for (const item of stateQuestionsList) {
        const tmp = await getFromCacheById(
            process.env.REACT_APP_STATE_QUESTIONS_TB,
            item,
        );
        if (tmp !== null) {
            fetchStateQuestions.push(tmp);
        }
    }

    const fetchGeneralQuestions = [];
    for (const item of generalQuestionsList) {
        const tmp = await getFromCacheById(
            process.env.REACT_APP_GENERAL_QUESTIONS_TB,
            item,
        );
        if (tmp !== null) {
            fetchGeneralQuestions.push(tmp);
        }
    }

    const results = await Promise.all([
        ...fetchStateQuestions,
        ...fetchGeneralQuestions,
    ]);

    questionsList = [...questionsList, ...results];
    // console.log(`Check the concated data: ${questionsList}`);

    return questionsList;
}
